import React, { useEffect, useState } from "react";
import "./OfferingContent.scss";
import { getAdjustedPrice, getPrice, logger } from "../../utilities";
import { Button, Colors, InputField } from "../index";
import { ButtonType } from "@KrashidBuilt/hotsauce-common/src/utils/StyledTheme";
import { useAppStore } from "../../data/AppStore";
import { shallow } from "zustand/shallow";
import { useNavigate } from "react-router-dom";

const LOG_PREFIX = "[OfferingContentNavigation.js]";

const OfferingContentNavigation = ({
  showButton,
  offering,
  relation,
  cartCallback,
}) => {
  const [state, _setState] = useState({
    buying: false,
    mandatoryEnteredUnit: 0,
  });
  const setState = (newState) => _setState(Object.assign({}, state, newState));
  const { buying, mandatoryEnteredUnit } = state;
  const [COMPANY, OFFERINGS, RELATIONS, CART, CLIENT, rectifyCART] =
    useAppStore(
      (state) => [
        state.COMPANY,
        state.OFFERINGS,
        state.RELATIONS,
        state.CART,
        state.CLIENT,
        state.rectifyCART,
      ],
      shallow
    );

  // Return null if essential data isn't loaded
  if (!Array.isArray(OFFERINGS) || OFFERINGS.length === 0) {
    return null;
  }
  logger.silly(LOG_PREFIX, "render", {
    showButton,
    offering,
    relation,
    cartCallback,
    ...state,
  });
  const navigate = useNavigate();

  useEffect(() => {
    let cartClone = JSON.parse(JSON.stringify(CART));
    rectifyCART(cartClone);
  }, []);

  const buildNavigation = () => {
    logger.debug(LOG_PREFIX, ".buildNavigation()");
    // Early return if RELATIONS is not ready
    if (!RELATIONS || !Array.isArray(RELATIONS)) {
      return null;
    }
    const flatRelations = RELATIONS.map((r) => [
      r,
      ...r.children.map((c) => [c, ...c.children.flat()]).flat(),
    ]).flat();
    const currentIndex = flatRelations.findIndex((o) => {
      return o.id === offering.id;
    });
    let nextIndex =
      currentIndex === flatRelations.length - 1 ? 0 : currentIndex + 1;
    let previousIndex =
      currentIndex === 0 ? flatRelations.length - 1 : currentIndex - 1;
    const presentInCart = CART.accepted.map((i) => i.id).includes(offering.id);
    const nextOffering = OFFERINGS.find(
      (o) => o.id === flatRelations[nextIndex].id
    );
    const prevOffering = OFFERINGS.find(
      (o) => o.id === flatRelations[previousIndex].id
    );

    const buyButton =
      offering.unit_type === "l/ft" ||
      offering.unit_type === "sq/ft" ||
      offering.unit_type === "l/in" ? (
        <>
          <InputField
            horizontalLayout={true}
            label={"Qty"}
            onChange={(e) => {
              console.log(e);
              setState({ mandatoryEnteredUnit: e.replace(/^0+/, "") });
            }}
            value={mandatoryEnteredUnit}
            type={"number"}
            min={0}
            clearIcon={false}
            placeholder={0}
          />
          <Button
            disabled={mandatoryEnteredUnit <= 0}
            className={buying ? "buyButton buying" : "buyButton"}
            onClick={() => cartCallback(offering, mandatoryEnteredUnit)}
            label={`${presentInCart ? "Added" : "Add"} ${getPrice(
              getAdjustedPrice(offering, CLIENT, COMPANY)
            )} (${offering.unit_type})`}
            type={ButtonType.Add}
          />
        </>
      ) : (
        <Button
          className={buying ? "buyButton buying" : "buyButton"}
          onClick={() => cartCallback(offering)}
          label={`${presentInCart ? "Added" : "Add"} ${getPrice(
            getAdjustedPrice(offering, CLIENT, COMPANY)
          )} (${offering.unit_type})`}
          type={ButtonType.Add}
        />
      );

    if (OFFERINGS.length > 1) {
      return (
        <>
          <Button
            onClick={() =>
              navigate(`/offering/${prevOffering.id}`, { replace: true })
            }
            label="Back"
            type={ButtonType.Backward}
            colorTheme={Colors.Orange}
          />
          {showButton && buyButton}
          <Button
            className="next"
            onClick={() =>
              navigate(`/offering/${nextOffering.id}`, { replace: true })
            }
            label="Next"
            type={ButtonType.Forward}
            colorTheme={Colors.Orange}
          />
        </>
      );
    } else {
      return buyButton;
    }
  };

  return <div className={"OfferingContentNavigation"}>{buildNavigation()}</div>;
};

export default OfferingContentNavigation;
